export default "__VITE_ASSET__BXDVVFdB__"